export enum JobFillOutAccordion {
  JOB_ASSESSMENT = 'JOB_ASSESSMENT',
  CHECKLISTS = 'CHECKLISTS',
  MESSAGES_OF_JOB = 'MESSAGES_OF_JOB',
  JOBS_OF_JOB = 'JOBS_OF_JOB',
  COMMENTS = 'COMMENTS',
  FILES = 'FILES',
  UPDATE_JOB_INFOS = 'UPDATE_JOB_INFOS',
  RESCHEDULE_APPOINTMENT = 'RESCHEDULE_APPOINTMENT',
  JOB_FROM_JOB = 'JOB_FROM_JOB',
  ADD_SPENT_TIME = 'ADD_SPENT_TIME',
  JOB_DETAILS = 'JOB_DETAILS',
}
